import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import ViewScurity from "./ViewScurity";
import { change_Lang } from "../../../actions/Helper_action";
import { Update_ScuretyBill } from "../../../actions_agent/Invoice_action";
export class View_Scurity extends Component {
  render() {
    const {
      scurety_view_obj,
      lang,
      change_Lang,
      user,
      Update_ScuretyBill,
      handleCancel,
    } = this.props;
    return (
      <Fragment>
        <div className="container-fluid">
          <ViewScurity
            scurety_view_obj={scurety_view_obj}
            lang={lang}
            change_Lang={change_Lang}
            user={user}
            Update_ScuretyBill={Update_ScuretyBill}
            handleCancel={handleCancel}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    scurety_view_obj: state.Invoice_Reducer.scurety_view_obj,
    user: state.AuthReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    Update_ScuretyBill: (id, data) => dispatch(Update_ScuretyBill(id, data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View_Scurity);
